import React from 'react';

export const MenuContext = React.createContext({
  activeMenuID: '',
  activeColor: '',
  closeMenu: () => {},
  openMenu: () => {},
});
export default MenuContext;
